import { render, staticRenderFns } from "./RedeemHistory.vue?vue&type=template&id=67de26fd&scoped=true"
import script from "./RedeemHistory.vue?vue&type=script&lang=js"
export * from "./RedeemHistory.vue?vue&type=script&lang=js"
import style0 from "./RedeemHistory.vue?vue&type=style&index=0&id=67de26fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67de26fd",
  null
  
)

export default component.exports